<template lang="pug">
  b-modal(
    v-if="dialogData && dialogData.context"
    v-model="show",
    header-class="lmm-common-popup-header",
    :title="dialogData.context.title"
    @shown="focusIn",
    no-close-on-backdrop)
    div(@keyup.enter="submit")
      // 멀티 선택이 아닌 경우 이름이 보이도록 한다.
      b-row(v-if='!dialogData.context.isMultipleSelection')
        b-col(cols="12")
          div.context.mb-4(v-html="$t(dialogData.context.namePath, dialogData.context.args)")
        b-col(cols="12" v-if="!dialogData.withoutInput")
          div.input-wrap
            div.mb-2.d-flex.justify-content-between
              span.context {{$t(dialogData.context.nameInputPath)}}
              div.limit(v-if="dialogData.limit")
                span(:class="{overlimit: value.length > dialogData.limit}") {{value.length}}
                | /
                span {{dialogData.limit}}
            b-form-input(
              ref="input"
              v-model="value",
              :placeholder="$t(dialogData.placeholder)")
      b-row
        b-col(cols="12")
          div.context.mb-2(
            v-if='!dialogData.context.isMultipleSelection'
            v-html="$t(dialogData.context.settingPath, dialogData.context.args)"
            )
          div.context.mb-2(v-else v-html="$t(dialogData.context.namePath, dialogData.context.args)")
        b-col(cols="12" v-if="!dialogData.withoutInput")
          div.input-wrap
            b-form-select(v-model='selectData.val' :options='selectData.options')
    template(slot="modal-footer", class="w-100")
      b-btn(
        v-if="!dialogData.withoutCancel",
        :size="dialogData.submit.size",
        @click="cancel") {{$t('cancel')}}
      b-btn(
        :size="dialogData.submit.size",
        :variant="dialogData.submit.color",
        :disabled="isSubmitDisabled",
        @click="submit", v-t="dialogData.submit.text")
</template>

<script>
import AppConfigsAPI from '../../../api/app-configs'
import rm from '@/components/device/remote'
import {DeviceAPI} from '@/api'

const defaultValues = {
  size: 'lg',
  title: '',
  context: '',
  submit: {
    size: 'sm',
    text: 'submit',
    color: 'secondary'
  },
  value: '',
  limit: null,
  placeholder: '',
  textarea: false,
  nullable: false,
  withoutInput: false,
  withoutCancel: false
}

let disabled = false

export default {
  name: 'agentInfoEditDialog',
  props: {
    dialogData: {
      type: Object,
      default: () => defaultValues
    }
  },
  data () {
    return {
      show: false,
      dialog: {},
      value: '',
      cb () {},
      selectData: {
        val: '',
        options: []
      }
    }
  },
  computed: {
    // 이름 또는 구성 둘 다 바뀌는 것이 없으면 확인 버튼 비활성화.
    isSubmitDisabled() {
      return (this.dialogData.limit && this.value.length > this.dialogData.limit) ||
          (this.dialogData.value === this.value && this.dialogData.appConfigPk === this.selectData.val);
    },
    // 드롭다운에서 appConfig 의 pk 값 뿐만 아니라 name 값도 갖고 오기 위함.
    selectedText() {
      const selectedOption = this.selectData.options.find(option => option.value === this.selectData.val);
      return selectedOption ? selectedOption.text : '';
    }
  },
  watch: {
    dialogData: {
      handler(newVal) {
        if (newVal && newVal.context) {
          this.show = true;
          this.value = newVal.value || '';
          this.dialogData.context.title = newVal.context.title || '';
          this.selectData.val = newVal.appConfigPk
        }
      },
      immediate: true,
      deep: true,
    }
  },
  mounted() {
    this.fetchAppConfigInfoList()
  },
  methods: {
    // 구성 정보를 표현하는 드롭다운에 정보를 주기 위한 메서드
    async fetchAppConfigInfoList() {
      let res = await AppConfigsAPI.get('')
      const {objects, status} = res.data

      if (status !== 200) {
        this.$awn.warning(this.$t('data_get_fail'))
        return []
      }

      this.selectData.options = objects.map(obj => ({
        value: obj.pk,
        text: obj.config_name
      }));
    },
    focusIn () {
      disabled = false
      if (this.dialogData.withoutInput || this.dialogData.context.isMultipleSelection) return
      if (this.dialogData.textarea) setTimeout(() => (this.$refs.textarea.focus()), 600)
      else setTimeout(() => (this.$refs.input.focus()), 600)
    },
    submit () {
      if (disabled) return
      disabled = true
      if (this.dialogData.withoutInput === false && !this.value && !this.dialogData.nullable) {
        this.$awn.warning(this.$t('no_input_data'))
        disabled = false
        return
      }
      
      if (this.dialogData.userList) {
        let uidArray = this.dialogData.userList.map(i => i.uid)
        rm['information'](uidArray)
        
        let requests = this.dialogData.userList.map(device => {
          return DeviceAPI.put(device.devicePk.toString(), { app_config_fk: this.selectData.val })
        })
        
        Promise.all(requests)
            .then(response => {
              this.$awn.success(this.$t("app_config_info_updated"))
              this.$emit('submit', null)
            })
            .catch(error => {
              this.$awn.error(error.message)
              console.error(error)
            })
      } else {
        rm['information'](this.dialogData.guid)
        let params = {
          oldValue: this.dialogData.value,
          newValue: this.value,
          devicePk: this.dialogData.devicePk,
          oldConfigName: this.dialogData.appConfigName,
          newConfigName: this.selectedText,
          appConfigPk: this.selectData.val,
        }
        this.$emit('submit', params) // 이벤트 발생
      }
      this.value = ''
      this.show = false
    },
    cancel () {
      this.$emit('cancel') // 이벤트 발생
      this.value = ''
      this.show = false
    },
  },
}
</script>


<style lang="scss" scoped src="../../dialogs/dialogs.scss"></style>
<style lang="scss" scoped>
.limit {
  text-align: right;
}
.overlimit {
  color: red;
}


::v-deep .modal-header {
  background-color: #FAFAFA !important;
  padding: 1rem 1rem 0.75rem 1rem;
  h5 {
    font-size: 1.1rem;
    font-weight: 550;
  }
}

::v-deep .modal-footer {
  border: none;
  padding: 0 1rem 1rem 1rem
}

.btn-primary {
  color: white;
  &:hover {
    color: white;
  }
  &:active{
    color: white;
  }
}

.btn-secondary {
  color: #6F6F6F !important;
  background-color: #FFFFFF;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.context {
  font-size: 0.9rem;
  color: #545B64;
}

::v-deep .modal-dialog {
  max-width: 700px !important;
}
</style>